quoteModule.controller('productFilteringController',
    ['$scope', 'profitSettingsService', 'quoteIntegrationService', 'tuxFabMenuEvents', 'vehicleProductsProcessingService', 'settingsCacheService',
        'imSessionVarsService', 'erateSessionVarsService', 'vehicleProductService', 'rateQuoteCoordService', 'quoteIntegrationService',
        'quoteCreationEvents',
        function ($scope, profitSettingsService, quoteIntegrationService, tuxFabMenuEvents, vehicleProductsProcessingService, settingsCacheService,
                  imSessionVarsService, erateSessionVarsService, vehicleProductService, rateQuoteCoordService, quoteIntegrationService, quoteCreationEvents) {
            var self = this;
            $scope.productFilteringList = [];
            $scope.previousFilteredCodes = [];      // to be compared with ...
            var _referenceData = Date.today();
            $scope.showForceLoad = false;
            $scope.forceLoadChecked = false;
            $scope.loading = false;

            this.init = function(element) {
                self.$element = element;
            }

            function getFilteredProductCodes(productsFromWeb){
                var filteredProds = _.filter(productsFromWeb, function (item) {
                    return item && item.checked;
                });
                return (filteredProds && filteredProds.length > 0) ? filteredProds.map(function(item) { return item.productCode }) : [];
            }

            function productSelectionChanged(previous, current) {
                if (previous.length != current.length) return true;
                var selectionChanged = false;
                previous.forEach(function(item) {
                    if (!current.includes(item)) selectionChanged = true;
                });
                return selectionChanged;
            }

            function savePreviousState() {
                $scope.previousFilteredCodes = getFilteredProductCodes($scope.productFilteringList);
                vehicleProductsProcessingService.setFilteringProductsChanged(false);        // init it to false ...
            }

            // whenever a product clicked, tracking the change and put it in the product processing service ...
            $scope.productClick = function($event, code) {
                var newProds = getFilteredProductCodes($scope.productFilteringList);
                var selectionChanged = productSelectionChanged($scope.previousFilteredCodes, newProds);
                vehicleProductsProcessingService.setFilteringProductsSelection(selectionChanged, newProds);
            }

            $scope.forceLoadClick = function (evt) {
                vehicleProductsProcessingService.setForceLoadProducts(evt.target.checked);
            }

            // save this to be compared with ...
            // don't need the closed event, since the selection changes are tracked by the checkboxes click ...
            $scope.$on(tuxFabMenuEvents.shown, function() {
                savePreviousState();
            });

            $scope.$on(quoteCreationEvents.filteringProductRetrieved, function(event, gotFilteringProducts){
                $scope.productFilteringList = gotFilteringProducts;
                $scope.loading = true;
                savePreviousState();
            });

            $scope.$on(quoteCreationEvents.loadingExistingQuote, function() {
                $scope.showForceLoad = true;
            });

            $scope.$on(quoteCreationEvents.unCheckForceLoading, function(event, args){
                // it is doing the cleaning in the rate queue, un-check the force loading now
                $scope.forceLoadChecked = false;
                vehicleProductsProcessingService.setForceLoadProducts(false);
            });

        }]);
